import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate: 'PAYROLL_UPDATE',
    smsDelete: 'PAYROLL_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state: {
        payroll_items: [],
        inclusion_items: [],
        deduction_items: [],
        designation_payroll: [],
        designation_payroll_count: null,
        payroll_by_designation: {},
        payroll_list: [],
        payroll_details: {},
        payroll_history: [],
        payroll_list_count:null,

        payrollLoading: false,
        payrollError: false,
        payrollDesignationLoading: false,
        payrollDesignationError: false,

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        payroll_slip:[],
        payroll_slip_count:null,

        my_payroll_slip:[],
        my_payroll_slip_count:null,
        bank_details: true,

        payroll_sheet:[],
        payroll_sheet_count:null,
        payroll_sheet_detail:[],
        payroll_sheet_detail_count: null,

        disbursement_sheet: [],
        disbursement_sheet_count: null,

        disbursementLoading :false,
        disbursementError :false,

        disbursement_detail:{},

        ...store
    },

    mutations: {
        ...mutations,

        SET_PAYROLL_SLIP(state, {results, pg_count}) {
            state.payroll_slip = results,
            state.payroll_slip_count = pg_count
        },
        SET_MY_PAYROLL_SLIP(state, {results, pg_count, bank_details}) {
            state.my_payroll_slip = results,
            state.my_payroll_slip_count = pg_count
            state.bank_details = bank_details
        },
        SET_PAYROLL_SHEET(state, {results, pg_count}) {
            state.payroll_sheet = results,
            state.payroll_sheet_count = pg_count
        },
        SET_DISBURSEMENT_SHEET(state, {results, pg_count}) {
            state.disbursement_sheet = results,
            state.disbursement_sheet_count = pg_count
        },
        SET_PAYROLL_SHEET_DETAIL( state, {results, pg_count}) {
            state.payroll_sheet_detail = results,
            state.payroll_sheet_detail_count = pg_count
        },

        SET_PAYROLL_ITEMS(state, items) {
            state.payroll_items = items
        },

        SET_DEDUCTIVE_PAYROLL_ITEMS(state, items) {
            state.deduction_items = items
        },

        SET_INCLUSIVE_PAYROLL_ITEMS(state, items) {
            state.inclusion_items = items
        },

        SET_DESIGNATION_PAYROLL(state, {results,pg_count}) {
            state.designation_payroll = results
            state.designation_payroll_count = pg_count
        },

        SET_PAYROLL_BY_DESIGNATION(state, items) {
            state.payroll_by_designation = items
        },

        SET_PAYROLL_LIST(state, {results, pg_count}) {
            state.payroll_list = results,
            state.payroll_list_count = pg_count
        },

        SET_PAYROLL_DETAILS(state, item) {
            state.payroll_details = item
        },

        SET_PAYROLL_HISTORY_LIST(state, item) {
            state.payroll_history = item
        },
        SET_DISBURSEMENT_DETAIL(state, detail) {
            state.disbursement_detail = detail
        },

        PAYROLL_LOADING (state, loading) {
            state.payrollLoading = loading;
        },

        PAYROLL_ERROR (state, hasError) {
            state.payrollError = hasError;
        },

        DISBURSEMENT_LOADING (state, loading) {
            state.disbursementLoading = loading;
        },

        DISBURSEMENT_ERROR (state, hasError) {
            state.disbursementError = hasError;
        },

        PAYROLL_DESIGNATION_LOADING (state, loading) {
            state.payrollDesignationLoading = loading;
        },

        PAYROLL_DESIGNATION_ERROR (state, hasError) {
            state.payrollDesignationError = hasError;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async fetchMyPayrollSlipList ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                
                let url = V1API.get_my_payroll_slip + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count, bank_details} = result.data
                commit('SET_MY_PAYROLL_SLIP', {results, pg_count, bank_details});
                
            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async fetchPayrollSlipList ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                
                let url = V1API.get_payroll_slip + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_PAYROLL_SLIP', {results, pg_count});
                
            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async fetchPayrollSheetList ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                
                let url = V1API.get_payroll_sheet + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_PAYROLL_SHEET', {results, pg_count});
                
            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },
        async fetchPayrollSheetDetail ({ commit,dispatch }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.department) params.append('department', payload.department);
                if (payload.designation) params.append('designation', payload.designation);
                if (payload.is_disbursed) params.append('is_disbursed', payload.is_disbursed);
                
                
                let url = V1API.get_payroll_sheet_detail + payload.sheet_id + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_PAYROLL_SHEET_DETAIL', {results, pg_count});
                
            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async finalisePayrollSheet ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.finalise_payroll_sheet + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchPayrollSheetList', {currentPage:payload.currentPage, perPage:payload.perPage})

            return response
        },

        async generatePayrollSheet ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.generate_payroll_sheet, {
                    month: payload.month,
                    year: payload.year
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPayrollSheetList', {currentPage:payload.currentPage, perPage:payload.perPage})
                return response

            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
        async generateDisbursement ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
            const result = await axios.post(
                        V1API.create_disbursement,
                        payload.disbursement,
                        config
                    )
                    const data = result.data

                    if (data.code == 200) {
                         await dispatch('addEmployeeinDisbursement', {
                            disbursement: data.data.id,
                            entries: payload.entries
                        })
                            await dispatch('fetchDisbursementList', {
                                payrollSheet: payload.payrollSheet
                            });
                             commit('SUBMIT_SUCCESS', true);

                    }
                       
                return data
        
    
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },
       


        async addEmployeeinDisbursement ({commit, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.add_entry_in_disbursement + payload.disbursement, 
                    {
                        entries: payload.entries
                    }
                    , config).then(result=>{
                                    let data = result.data
                                    return data
                                });

                                commit('SUBMIT_SUCCESS', true)
                                return response

                            }catch (e) {
                                commit('SUBMIT_ERROR', true);
                            }finally {
                                commit('SUBMIT_LOADING', false);
                            }
        },
        async fetchDisbursementDetail({ commit }, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const response = await axios.get(
                    V1API.disbursement_sheet_detail + payload,
                    config
                );

                commit(
                    'SET_DISBURSEMENT_DETAIL',
                    response.data.data
                );

                return response.data;

            } catch (e) {
                commit('SUBMIT_ERROR', true);
            
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },
    

        async fetchPayrollItems ({ commit }) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_payroll_items, config);
                let items = result.data.data

                commit('SET_PAYROLL_ITEMS', items);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
           
        },

        async fetchInclusivePayrollItems ({ commit }) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_inclusive_payroll_items, config);
                let items = result.data.data

                commit('SET_INCLUSIVE_PAYROLL_ITEMS', items);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            commit('PAYROLL_LOADING', false);
        },

        async fetchDeductivePayrollItems ({ commit }) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_deductive_payroll_items, config);
                let items = result.data.data

                commit('SET_DEDUCTIVE_PAYROLL_ITEMS', items);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            commit('PAYROLL_LOADING', false);
        },

        async addPayrollItems ({commit, dispatch}, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_payroll_item, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPayrollItems')
                return response

            }catch (e) {
                commit('PAYROLL_ERROR', true);
            }finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async updatePayrollItems ({commit, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                  }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,

                async () => {
                    response = await axios.patch(V1API.edit_payroll_item + payload.id, {
                        name: payload.name,
                        status: payload.status

                    }, config).then(result => {
                        let data = decode(result.data)
                        return data
                    })

                    dispatch('fetchPayrollItems');

                }
            )
            return response
        },

        async deletePayrollItem ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_payroll_item + payload, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchPayrollItems');

            return response
        },

        // Designation - Payroll
        async fetchDesignationPayroll ({ commit },payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };
            try{
                let params = new URLSearchParams();
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
               
                let url = V1API.get_designation_payroll + '?' + params.toString();
                let result = await axios.get(url, config);
    
                const {results, pg_count} = result.data
              
                commit('SET_DESIGNATION_PAYROLL', {results, pg_count});



                // let result = await axios.get(V1API.get_designation_payroll, config);
                // let items = result.data.data

                // commit('SET_DESIGNATION_PAYROLL', items);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async addDesignationPayroll ({commit, dispatch}, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_designation_payroll, {
                    department: payload.designation_payroll.department,
                    designation: payload.designation_payroll.designation,
                    inclusion: payload.inclusions,
                    deduction: payload.deductions,
                    gross_salary: payload.gross_salary

                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchDesignationPayroll', {currentPage:payload.page, perPage:payload.perPage})
              
                return response

            }catch (e) {
                commit('PAYROLL_ERROR', true);
            }finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async updateDesignationPayroll ({commit, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                  }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,

                async () => {
                    response = await axios.patch(V1API.edit_designation_payroll + payload.id, {
                        inclusion: payload.inclusions,
                        deduction: payload.deductions,
                        gross_salary: payload.gross_salary

                    }, config).then(result => {
                        let data = decode(result.data)
                        return data
                    })

                    dispatch ('fetchDesignationPayroll', {currentPage:payload.page, perPage:payload.perPage})

                }
            )
            return response
        },

        async deleteDesignationPayroll ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_designation_payroll + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchDesignationPayroll', {currentPage:payload.page, perPage:payload.perPage})

            return response
        },

        // Employee Payroll
        async fetchPayrollByDesignation ({ commit }, payload) {
            commit('PAYROLL_DESIGNATION_LOADING', true);
            commit('PAYROLL_DESIGNATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_payroll_by_designation + payload, config);
                let items = result.data.data

                commit('SET_PAYROLL_BY_DESIGNATION', items);
                return items

            } catch(error) {
                commit('PAYROLL_DESIGNATION_ERROR', true);
            }
            commit('PAYROLL_DESIGNATION_LOADING', false);
        },

        async addEmployeePayroll ({commit, dispatch}, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_employee_payroll, {
                    employee: payload.payroll.employee,
                    department: payload.payroll.department,
                    designation: payload.payroll.designation,
                    inclusion: payload.inclusions,
                    deduction: payload.deductions,
                    gross_salary: payload.gross_salary

                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPayrollList', {perPage:payload.perPage, currentPage:payload.currentPage, search_term:payload.search_term, employee:payload.employee, department:payload.department, designation:payload.designation})
                return response

            }catch (e) {
                commit('PAYROLL_ERROR', true);
            }finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async editEmployeePayroll ({commit, dispatch}, payload) {
            let response='';
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                  }
            };

            await performNetworkCall(
                commit,
                keyList.smsUpdate,

                async () => {
                    response = await axios.patch(V1API.edit_employee_payroll + payload.id, {
                        inclusion: payload.inclusions,
                        deduction: payload.deductions,
                        gross_salary: payload.gross_salary

                    }, config).then(result => {
                        let data = decode(result.data)
                        return data
                    })

                    dispatch('fetchEmployeePayrollDetails', payload.id);

                }
            )
            return response
        },

        async fetchPayrollList ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.department) params.append('department', payload.department);
                if (payload.designation) params.append('designation', payload.designation);
                if (payload.employee) params.append('employee', payload.employee);
                
                let url = V1API.get_employee_payroll + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_PAYROLL_LIST', {results, pg_count});
                

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async deletePayroll ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_employee_payroll + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchPayrollList', {perPage:payload.perPage, currentPage:payload.currentPage, search_term:payload.search_term, employee:payload.employee, department:payload.department, designation:payload.designation});

            return response
        },

        async fetchEmployeePayrollDetails ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_payroll_details + payload, config);
                let item = result.data.data

                commit('SET_PAYROLL_DETAILS', item);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async fetchEmployeePayrollHistory ({ commit }, payload) {
            commit('PAYROLL_LOADING', true);
            commit('PAYROLL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_payroll_history + payload, config);
                let items = result.data.data

                commit('SET_PAYROLL_HISTORY_LIST', items);

            } catch(error) {
                commit('PAYROLL_ERROR', true);
            }
            finally {
                commit('PAYROLL_LOADING', false);
            }
        },

        async toggleEmployeePayroll ({ commit, dispatch }, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.toggle_payroll_active + payload.id, config).then(result => {
                let items = result.data

                dispatch('fetchEmployeePayrollDetails', payload.e_id)
                dispatch('fetchEmployeePayrollHistory', payload.e_id)

                return items
            })

            return response
        },

        async deletePayrollHistory ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_employee_payroll + payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchEmployeePayrollDetails', payload.e_id)
            dispatch('fetchEmployeePayrollHistory', payload.e_id)

            return response
        },

        // Disbursement Sheet
        async fetchDisbursementList ({ commit,dispatch }, payload) {
            commit('DISBURSEMENT_LOADING', true);
            commit('DISBURSEMENT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
             
                
                
                let url = V1API.disbursement_sheet_list + payload.payrollSheet+ '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data
                commit('SET_DISBURSEMENT_SHEET', {results, pg_count});
                
            } catch(error) {
                commit('DISBURSEMENT_ERROR', true);
            }
            finally {
                commit('DISBURSEMENT_LOADING', false);
            }
        },
        async tooggleDisbursement ({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.disbursement_toggle + payload.status + '/' +  payload.id, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch('fetchDisbursementList', {perPage:payload.perPage, currentPage:payload.currentPage, payrollSheet: payload.payrollSheet});
            if( payload.status === 'disburse'){
                dispatch('fetchPayrollSheetDetail', {sheet_id:payload.payrollSheet, perPage:payload.perPage, currentPage:payload.currentPage, search_term:payload.search_term, department: payload.department, designation:payload.designation,is_disbursed:payload.is_disbursed})
            }
         

            return response
        },
    },

    getters: {}
}
